<section class="info-banner">
  <mat-icon aria-hidden="true">info_outline</mat-icon>
  <span>{{ "repository.siteGroups.info" | translate }}</span>
</section>

<section class="creation-form">
  <button
    *ngIf="!isCreationMode"
    (click)="onEdit()"
    [matTooltip]="'repository.siteGroups.list.add' | translate"
    mat-mini-fab
    class="action-button"
    color="primary"
  >
    <mat-icon aria-label="Add">add</mat-icon>
  </button>
  <app-site-group-edit
    *ngIf="isCreationMode && !editedId"
    [sites]="sites"
    (editFinished)="onEditFinished()"
  ></app-site-group-edit>
</section>

<mat-form-field class="filterField">
  <mat-label>{{ "repository.siteGroups.filter" | translate }}</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Votre filtre"
    #input
  />
</mat-form-field>

<section class="datatable-container">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.siteGroups.list.name" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <strong>{{ group.name }}</strong>
      </td>
    </ng-container>

    <ng-container matColumnDef="sites">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.siteGroups.list.sites" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ul>
          <li *ngFor="let name of getDisplayedMembers(group)">{{ name }}</li>
          <li *ngIf="getRemainingMembersCount(group) > 0">
            <button
              mat-button
              color="primary"
              class="show-more-sites"
              type="button"
              (click)="toggleSites(group)"
            >
              {{
                isSitesExpanded(group)
                  ? "réduire"
                  : ("repository.siteGroups.list.others"
                    | translate: { count: getRemainingMembersCount(group) })
              }}
            </button>
          </li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ "repository.siteGroups.list.actions" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ng-container *ngIf="group.id !== editedId">
          <button
            mat-icon-button
            class="action-button"
            color="primary"
            [disabled]="isLoading"
            [matTooltip]="'repository.siteGroups.list.edit' | translate"
            (click)="onEdit(group.id)"
          >
            <mat-icon aria-label="Edit">edit</mat-icon>
          </button>
        </ng-container>
        <ng-container>
          <button
            mat-icon-button
            class="action-button"
            color="primary"
            [disabled]="isLoading"
            [matTooltip]="'repository.siteGroups.list.delete' | translate"
            (click)="delete(group.id)"
          >
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let group"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          *ngIf="group.id === editedId"
          class="row-edit"
          [@detailExpand]="group.id === editedId ? 'expanded' : 'collapsed'"
        >
          <app-site-group-edit
            [siteGroup]="group"
            [sites]="sites"
            (editFinished)="onEditFinished()"
          ></app-site-group-edit>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="row"
      [ngClass]="{ 'expanded-row': row.id === editedId }"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="detail-row"
    ></tr>
  </table>
  <mat-paginator
    class="paginator"
    [pageSizeOptions]="[20, 25, 50, 100]"
    showFirstLastButtons
  ></mat-paginator>
</section>
<mat-progress-bar
  *ngIf="isLoading"
  class="progress-bar"
  mode="indeterminate"
  color="primary"
></mat-progress-bar>
